import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsHikeNormalLarge = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M46.75 32.16A4.31 4.31 0 0043.48 29c-3.17-.63-7.07-1.67-8-1.93l-11.57-9.61L22 7.8a1 1 0 00-1-.8 16.24 16.24 0 00-10.39 4H5a1 1 0 00-1 .91C3.92 12.81 2 34 2 36c0 3.25 3.75 5 7.28 5h6a4.42 4.42 0 003-1.38c.43-.38.71-.62 1-.62a27.32 27.32 0 016.55.87A38.53 38.53 0 0035.28 41c6.41 0 9.31-2.9 10.71-4.29a4.73 4.73 0 00.76-4.55zM11 12a15.3 15.3 0 0110-4l1.8 9H4.55c.26-2.93.45-5 .45-5zm34.28 24c-1.32 1.32-4 4-10 4-8 0-10-2-16-2-1.39 0-2 2-4 2h-6C5.28 40 3 38 3 36c0-1.32.87-11.33 1.46-18H23l2.18 1.81L22 22.5a.5.5 0 00.32.88.49.49 0 00.32-.12l3.36-2.8 4 3.33-3 2.52a.5.5 0 10.65.76l3.08-2.63 4 3.33L32 30.12a.5.5 0 10.65.76l3.14-2.68c1.45.39 4.75 1.24 7.53 1.8s3.28 4.68 1.96 6z"
  }));
});
SvgSportsHikeNormalLarge.defaultProps = {
  height: 48,
  width: 48
};
SvgSportsHikeNormalLarge.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsHikeNormalLarge;